import React from 'react';
import CRUDManager from '../../../../shared/components/crud/CRUDManager';
import { supplierManagementConfig } from '../config/supplierManagementConfig';

export default function SupplierManagement() {
  return <CRUDManager config={supplierManagementConfig} />;
}